import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

const { colors, fontSizes, spaces } = theme;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledText = styled(forwardRef(({ bold, color, noBottomSpace, ...props }, ref) => <div ref={ref} {...props} />))`
  margin-bottom: ${spaces.regular}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  font-weight: 400;
  color: ${({ color }) => color};

  span {
    color: ${colors.orange[500]};
  }

  ${({ bold }) =>
    bold &&
    css`
      font-weight: 500;
    `}

  ${({ noBottomSpace }) =>
    noBottomSpace &&
    css`
      margin-bottom: ${spaces.small2X}px;
    `}
`;

const Text = ({ children, bold, color, required, noBottomSpace }) => (
  <StyledText
    bold={bold}
    color={color || colors.gray[800]}
    noBottomSpace={noBottomSpace}
  >
    {children}
    {required && <span>&nbsp;*</span>}
  </StyledText>
);

Text.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  bold: PropTypes.bool,
  color: PropTypes.string,
  required: PropTypes.bool,
  noBottomSpace: PropTypes.bool,
};

export default Text;
